import { DailyCheckInDetailsResponse } from "../../types/rewards";

export const getDailyCheckInDetailsModel = (
  response: DailyCheckInDetailsResponse
): DailyCheckInDetailsResponse => response;
